<template>
  <div>
		<v-autocomplete 
			label="Product"
			v-model="selectedProduct"
			solo
			return-object
			hide-details
			clearable
			:items="products"
			@change="()=>{
				
			}"
		>
		</v-autocomplete>
		<v-layout row wrap ma-2>
			<v-flex xs12>
				<v-btn 
					@click="dialogAdd = true" 
					fab 
					absolute 
					right 
					top 
					small
					color="primary" 
					dark
				>
					<v-icon>add</v-icon>
				</v-btn>
				<v-dialog v-model="dialogAdd" persistent max-width="290">
					<v-card>
						<v-card-title class="headline">Add a new Product?</v-card-title>
						<v-card-text>
							<v-layout row wrap>
								<v-flex xs12>
									<v-text-field
										label="Product Name"
										required
										v-model="nName"
									></v-text-field>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										label="Product SKU"
										required
										v-model="nSKU"
									></v-text-field>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										label="Price Name"
										required
										v-model="nKey"
									></v-text-field>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										label="Price in $"
										required
										v-model="nPrice"
									></v-text-field>
								</v-flex>
							</v-layout>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="red darken-1" flat @click="dialogAdd = false">Cancel</v-btn>
							<v-btn :disabled="!nKey || !nPrice || !nName || !nSKU" color="green darken-1" flat @click="addProduct()">add</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-flex>
			<v-flex xs12>
				<v-card>
					<v-layout v-if="selectedProduct && superAdmin" row wrap align-center pa-3>
						<v-flex v-for="(key , i) in Object.keys(selectedProduct).filter(x=>{
								let noK = ['import_date', 'item_name', 'sku', 'key', 'text']
								let notAtAll = ['import_date', 'key', 'text']
								if( noK.indexOf(x) != -1 && notAtAll.indexOf(x) == -1 ) {
									return x
								}
							})" :key="i" xs12>
							<v-layout v-if="selectedProduct[key]" row wrap align-baseline>
								<v-flex xs5 class="text-xs-center font-weight-medium subtitle-1" px-2>
									{{ key.toUpperCase() }} 
								</v-flex>
								<v-flex xs5>
										<v-text-field
											v-model="selectedProduct[key]"
											hide-details
										></v-text-field>
								</v-flex>
								<v-flex xs1 class="text-xs-center">
									<v-btn @click="updateKey(key, selectedProduct[key])" color="primary" icon flat dark px-2>
										<v-icon size="16px">save</v-icon>
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 class="text-xs-center">
							<v-btn 
								@click="dialogDelete = true" 
								large
								color="error" 
								dark
								outline
							>
								<v-icon left>close</v-icon>
								delete product
							</v-btn>
							<v-dialog v-model="dialogDelete" persistent max-width="290">
								<v-card>
									<v-card-title class="headline">Are you shure you want to delete {{selectedProduct.item_name}}?</v-card-title>
									<v-card-text>
										<v-layout row wrap>
											<v-flex xs12>
												Are you that you want to delete and all related data? this may affect past orders and any calculations done by the system
											</v-flex>
										</v-layout>
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn color="red darken-1" flat @click="dialogDelete = false">Cancel</v-btn>
										<v-btn :disabled="!selectedProduct" color="green darken-1" flat @click="deleteProduct()">delete</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap ma-2>
			<v-flex xs12>
				<v-card>
					<v-layout v-if="selectedProduct" row wrap align-center pa-3>
						<v-flex v-for="(key , i) in ['clearance_name_ar', 'clearance_name_en']" :key="i+key" xs12>
							<v-layout row wrap align-baseline>
								<v-flex xs5 class="text-xs-center font-weight-medium subtitle-1" px-2>
									{{ key.toUpperCase() }}
								</v-flex>
								<v-flex v-if="key == 'clearance_name_ar' || key ==  'clearance_name_en'" xs5>
									<v-text-field
										v-model="selectedProduct[key]"
										hide-details
									></v-text-field>
								</v-flex>
								<v-flex xs1 class="text-xs-center">
									<v-btn @click="updateKey(key, selectedProduct[key])" color="primary" icon flat dark px-2>
										<v-icon size="16px">save</v-icon>
									</v-btn>
								</v-flex>
								<v-flex v-if="superAdmin" xs1 class="text-xs-center">
									<v-btn @click="removePrice(key)" color="error" icon flat dark px-2>
										<v-icon size="16px">close</v-icon>
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 mt-2>
							<v-layout row wrap>
								<v-flex v-for="(warehouse, k) in selectedProduct.warehouse" :key="k" xs12>
									<v-card>
										<v-layout row wrap align-center pa-4>
											<v-flex xs2 px-1>
												Warehouse
												<v-autocomplete
													:items="warehouses"
													v-model="selectedProduct.warehouse[k].warehouse"
													label="Select a warehouse"
													return-object
													solo
													clearable
													hide-details
													:loading="loading"
													:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
													@click:append-outer="addWarehouseD = true"
												></v-autocomplete>
												<v-dialog v-model="addWarehouseD" persistent max-width="290">
													<v-card>
														<v-card-title class="headline">You want to add a Warehouse?</v-card-title>
														<v-card-text>
															<v-layout row wrap>
																<v-flex xs12>
																	<v-text-field
																		label="Name"
																		required
																		v-model="warehouseName"
																	></v-text-field>
																</v-flex>
																<v-flex xs12>
																	<v-autocomplete
																		:items="countries"
																		v-model="warehouseCountry"
																		label="Select a country"
																		return-object
																		solo
																		clearable
																		hide-details
																		:loading="loading"
																	></v-autocomplete>
																</v-flex>
															</v-layout>
														</v-card-text>
														<v-card-actions>
															<v-spacer></v-spacer>
															<v-btn color="red darken-1" flat @click="addWarehouseD = false">Cancel</v-btn>
															<v-btn :disabled="!warehouseName" color="green darken-1" flat @click="addWarehouseToDB()">add</v-btn>
														</v-card-actions>
													</v-card>
												</v-dialog>
											</v-flex>
											<v-flex xs1 px-1>
												Quantity
												<v-text-field
													v-model="selectedProduct.warehouse[k].quantity"
													hide-details
													@keypress="isNumber($event)"
													solo
												></v-text-field>
											</v-flex>
											<v-flex xs2 px-1>
												Country
												<v-autocomplete
													:items="countries"
													v-model="selectedProduct.warehouse[k].country"
													label="Select a country"
													return-object
													solo
													multiple
													chips
													deletable-chips
													small-chips
													clearable
													hide-details
													:loading="loading"
												></v-autocomplete>
											</v-flex>
											<v-flex xs2 px-1>
												Price
												<v-autocomplete
													:items="clearancePrices"
													v-model="selectedProduct.warehouse[k].clearance_price_object"
													label="Select a price"
													return-object
													solo
													clearable
													hide-details
													:loading="loading"
												></v-autocomplete>
											</v-flex>
											<v-flex xs1 px-1>
												Priority
												<v-text-field
													v-model="selectedProduct.warehouse[k].priority"
													hide-details
													@keypress="isNumber($event)"
													solo
												></v-text-field>
											</v-flex>
											<v-flex xs2 px-1>
												Category
												<v-autocomplete
													:items="categories"
													v-model="selectedProduct.warehouse[k].category"
													label="Select a category"
													return-object
													solo
													clearable
													hide-details
													:loading="loading"
													:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
													@click:append-outer="addCategoryD = true"
												></v-autocomplete>
												<v-dialog v-model="addCategoryD" persistent max-width="290">
													<v-card>
														<v-card-title class="headline">You want to add a Category?</v-card-title>
														<v-card-text>
															<v-layout row wrap>
																<v-flex xs12>
																	<v-text-field
																		label="EN Name"
																		required
																		v-model="catenname"
																	></v-text-field>
																</v-flex>
																<v-flex xs12>
																	<v-text-field
																		label="AR Name"
																		required
																		v-model="catarname"
																	></v-text-field>
																</v-flex>
															</v-layout>
														</v-card-text>
														<v-card-actions>
															<v-spacer></v-spacer>
															<v-btn color="red darken-1" flat @click="addCategoryD = false">Cancel</v-btn>
															<v-btn :disabled="!catarname || !catenname" color="green darken-1" flat @click="addCategoryDB()">add</v-btn>
														</v-card-actions>
													</v-card>
												</v-dialog>
											</v-flex>
											<v-flex xs2 px-1 class="text-xs-center">
												<v-switch label="Clearance" v-model="selectedProduct.warehouse[k].clearance"></v-switch>
											</v-flex>
											<v-flex v-if="superAdmin" xs1 class="text-xs-center">
												<v-btn @click="removeWearhouse(k)" color="error" icon flat dark px-2>
													<v-icon size="16px">close</v-icon>
												</v-btn>
											</v-flex>
										</v-layout>
									</v-card>
								</v-flex>
								<v-flex xs12 class="text-xs-center">
									<v-btn @click="addWarehouse(selectedProduct.key)" color="primary" dark px-2>
										<v-icon left size="16px">add</v-icon>
										add a warehouseh
									</v-btn>
									<v-btn @click="saveWareHousesToProduct()" color="success" 
										v-if="selectedProduct.warehouse && selectedProduct.warehouse.length > 0" 
										dark 
										px-2>
										<v-icon left size="16px">save</v-icon>
										save warehousing
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap ma-2>
			<v-flex xs12>
				<v-card>
					<v-layout v-if="selectedProduct" row wrap align-center pa-3>
						<v-flex v-for="(key , i) in ['img', 'description_ar', 'description_en', 'name_ar', 'name_en']" :key="i+key" xs12>
							<v-layout row wrap align-baseline>
								<v-flex xs5 class="text-xs-center font-weight-medium subtitle-1" px-2>
									{{ key.toUpperCase() }}
								</v-flex>
								<v-flex v-if="key == 'img'" xs5>
										<v-text-field
											v-model="selectedProduct[key]"
											hide-details
											solo
											:loading="uploadProgress"
											append-outer-icon="cloud"
                      @click:append-outer="$refs.file[i].click()"
										></v-text-field>
										<img v-if="selectedProduct[key]" :src="selectedProduct[key]" width="300" alt="">
										<input
											type="file"
											style="display: none"
											ref="file"
											accept="csv/*"
											@change="onFilePicked"
										>
								</v-flex>
								<v-flex v-if="key == 'name_ar' || key == 'name_en'" xs5>
										<v-text-field
											v-model="selectedProduct[key]"
											hide-details
										></v-text-field>
								</v-flex>
								<v-flex v-if="key == 'description_ar' || key ==  'description_en'" xs5>
  									<vue-mce :config="config" v-model="selectedProduct[key]" />
								</v-flex>
								<v-flex xs1 class="text-xs-center">
									<v-btn @click="updateKey(key, selectedProduct[key])" color="primary" icon flat dark px-2>
										<v-icon size="16px">save</v-icon>
									</v-btn>
								</v-flex>
								<v-flex v-if="superAdmin" xs1 class="text-xs-center">
									<v-btn @click="removePrice(key)" color="error" icon flat dark px-2>
										<v-icon size="16px">close</v-icon>
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap ma-2>
			<v-flex xs12>
				<v-card>
					<v-layout v-if="selectedProduct" row wrap align-center pa-3>
						<v-flex v-for="(key , i) in Object.keys(selectedProduct).filter(x=>{
								let noK = ['import_date', 'item_name', 'sku', 'key', 'text', 'warehouse', 'clearance', 'img', 'description_ar', 'description_en', 'name_ar', 'name_en', 'clearance_name_ar', 'clearance_name_en']
								let notAtAll = ['import_date', 'key', 'text']
								if( noK.indexOf(x) == -1 && notAtAll.indexOf(x) == -1 ) {
									return x
								}
							})" :key="i" xs12>
							<v-layout v-if="selectedProduct[key]" row wrap align-baseline>
								<v-flex xs5 class="text-xs-center font-weight-medium subtitle-1" px-2>
									{{ key.toUpperCase() }}
								</v-flex>
								<v-flex xs5>
										<v-text-field
											v-model="selectedProduct[key]"
											hide-details
										></v-text-field>
								</v-flex>
								<v-flex xs1 class="text-xs-center">
									<v-btn @click="updateKey(key, selectedProduct[key])" color="primary" icon flat dark px-2>
										<v-icon size="16px">save</v-icon>
									</v-btn>
								</v-flex>
								<v-flex xs1 class="text-xs-center">
									<v-btn @click="removePrice(key)" color="error" icon flat dark px-2>
										<v-icon size="16px">close</v-icon>
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout v-if="selectedProduct" row wrap>
			<v-flex xs12 class="text-xs-center">
				<v-btn @click="dialog = true" color="primary" dark px-2>
					<v-icon left size="16px">add</v-icon>
					add a price
				</v-btn>
				<v-dialog v-model="dialog" persistent max-width="290">
					<v-card>
						<v-card-title class="headline">Define a new Price on {{ selectedProduct.item_name }}?</v-card-title>
						<v-card-text>
							<v-layout row wrap>
								<v-flex xs12>
									<v-text-field
										label="Price Name"
										required
										v-model="nKey"
									></v-text-field>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										label="Price in $"
										required
										v-model="nPrice"
									></v-text-field>
								</v-flex>
							</v-layout>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="red darken-1" flat @click="dialog = false">Cancel</v-btn>
							<v-btn :disabled="!nKey || !nPrice || !selectedProduct" color="green darken-1" flat @click="addPrice()">add</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-flex>

		</v-layout>
	</div>
</template>

<script>
import {firebase, db, auth, storageRef } from '@/fb';
import { getRandomInt, randomString, getCDate, check, uuid } from '@/customFunction';
import axios from 'axios';

export default {
  data() {
    return {
			config: {
        fontsize_formats: "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 39px 34px 38px 42px 48px",
        plugins: 'print preview fullpage powerpaste searchreplace autolink',
        toolbar1: 'formatselect fontsizeselect | bold italic strikethrough forecolor backcolor link',
      },
			loading:false,
			products:[],
			dialog:false,
			dialogAdd:false,
			selectedProduct:null,
			nKey:null,
			nPrice:null,
			nName:null,
			nSKU:null,
			dialogDelete:false,
			name:null,
			fileName:null,
			uploadURL:null,
			imgURLExt:null,
			uploadProgress:null,
			warehouses:[],
			addWarehouseD:false,
			warehouseName:null,
			warehouseCountry:null,
			countries:[],
			clearancePrices:[],
			addCategoryD:false,
			catenname:null,
			catarname:null,
			categories:[],
		}
	},
	methods:{
		async addCategoryDB(){
			await db.ref(`settings/clearancecategories`).push({
				ar:this.catarname,
				en:this.catenname
			})
			this.addCategoryD = false
			this.catenname = null
			this.catarname = null
			this.getCatsWare()
		},
		async getCatsWare(){
			let a = await db.ref(`settings/clearancecategories`).once('value').then(x=>x.val())
			let b = [...Object.values(a).map(x=>{return {...x, text:`${x.ar}:${x.en}`}})]
			this.categories = b
		},
		async addWarehouseToDB(){
			if(!this.warehouseName || !this.warehouseCountry) return true
			await db.ref(`settings/warehouses`).push({
				name:this.warehouseName,
				country:this.warehouseCountry
			})
			this.addWarehouseD = false
			this.getLoadData()
		},
		async getLoadData(){
			let w =	await db.ref(`settings/warehouses`).once('value').then(x=>x.val())
			for (const key in w) {
				if (w.hasOwnProperty(key)) {
					const warehouse = w[key];
					warehouse.key = key
					this.warehouses.push({
						text:warehouse.name,
						key:key,
						country:warehouse.country
					})
				}
			}
			let c = await db.ref(`countries`).once('value').then(x=>x.val())
			for (const key in c) {
				if (c.hasOwnProperty(key)) {
					const country = c[key];
					if(country.alpha2Code)
					this.countries.push({
						text:country.name,
						code:country.alpha2Code
					})
				}
			}
		},
		async saveWareHousesToProduct(){
			if (this.selectedProduct.warehouse) {
				console.log(this.selectedProduct.warehouse)
				for (let i = 0; i < this.selectedProduct.warehouse.length; i++) {
					const w = this.selectedProduct.warehouse[i];
					w.quantity = parseInt(w.quantity)
					w.priority = parseInt(w.priority)
				}
				await db.ref(`products/${this.selectedProduct.key}/warehouse`).set(this.selectedProduct.warehouse)
				this.$emit('snackbarNotification', `${this.selectedProduct.item_name} warehouses updated`, 'success')
				let c = this.selectedProduct.warehouse.filter(x=>x.clearance == true)
				if(c && c.length> 0){
					await db.ref(`products/${this.selectedProduct.key}`).update({
						clearance:true
					})
				} else {
					await db.ref(`products/${this.selectedProduct.key}`).update({
						clearance:false
					})
				}
				window.location.reload(false); 
			}
		},
		isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
		},
		removeWearhouse(k){
			this.selectedProduct.warehouse.splice(k, 1)
		},
		addWarehouse(key){
			console.log('a')
			this.selectedProduct.warehouse.push({
				country:'',
				warehouse:'',
				quantity:0,
				clearance_price:0,
				clearance:false,
			})
		},
		async getProducts(){
			await db.ref(`products`)
			.once('value').then( x => {
				let products = x.val()
				let productsArr = []
				for (const key in products) {
					if (products.hasOwnProperty(key)) {
						const product = products[key];
						product.key = key
						product.text = product.item_name
						if(!product.warehouse) product.warehouse = []
						productsArr.push(product)
					}
				}
				return this.products = productsArr
			})
		},
		updateKey(key, val) {
			console.log(this.selectedProduct.key)
			console.log(key)
			console.log(val)
			if(!val || !key || !this.selectedProduct || !this.selectedProduct.key) return
			db.ref(`products/${this.selectedProduct.key}`)
			.update({
				[key]:val
			})
			.then(x=>{
        this.$emit('snackbarNotification', `${key.toUpperCase()} is updated to ${val}`, 'success')
			})
		},
		addPrice(){
			let key = this.nKey.replace(/[\/\.\*\\#$\[\]\t\n\r\s]/g, '_')
			let p = this.nPrice
			db.ref(`products/${this.selectedProduct.key}`)
			.update({
				[key]:p
			})
			.then(x=>{
				this.$emit('snackbarNotification', `${key.toUpperCase()} is added and set to ${val}`, 'success')
				this.nKey = null
				this.nPrice = null
			})
		},
		removePrice(key) {
			
			db.ref(`products/${this.selectedProduct.key}`)
			.update({
				[key]:null
			})
			.then(x=>{
				this.selectedProduct[key] = null
        this.$emit('snackbarNotification', `${key.toUpperCase()} is removed`, 'success')
			})
		},
		async addProduct(){
			let product = {
				item_name:this.nName,
				sku:this.nSKU,
				[this.nKey.replace(/[\/\.\*\\#$\[\]\t\n\r\s]/g, '_')]: parseFloat(this.nPrice)
			}
			let x = await db.ref(`products`)
			.push(product);
			product.key = x.key;
			product.text = product.item_name;
			this.products.push(product);
			this.dialogAdd = false
			this.selectedProduct = product;
			this.$emit('snackbarNotification', `${product.item_name} is added`, 'success')

		},
		async deleteProduct(){
			let oKey = this.selectedProduct.key
			db.ref(`products`)
			.update({
				[this.selectedProduct.key]:null
			})
			.then(x=>{
				this.$emit('snackbarNotification', `${this.selectedProduct.item_name} is deleted`, 'success')
				let index = this.products.findIndex(x=> x.key == oKey)
				this.products.splice(index, 1)
				this.selectedProduct = null
				this.dialogDelete = false
			})
		},
		addImage(){
      console.log('s')
      this.pickFile()
    },
    pickFile() {
      this.$refs.file.click()
    },
    loadFile(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					this.uploadProgress = true
					this.selectedProduct.img = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.uploadURL = downloadURL
          this.imgURL = downloadURL
					this.loading = false
					this.uploadProgress = false
					console.log(this.selectedProduct)
					this.selectedProduct.img = downloadURL
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          console.log(this.file)
          this.imgURLExt = `.${this.file.name.split('.').pop()}`
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.fileName = null
        this.uploadURL = null
      }
    },
	},
	props: {
    userName: {
      required: true,
      default: null
    },
    userImage: {
      required: true,
      default: ''
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
	},
	watch:{
		selectedProduct(){
			let noK = ['import_date', 'item_name', 'sku', 'key', 'text', 'warehouse', 'clearance', 'img', 'description_ar', 'description_en', 'name_ar', 'name_en', 'clearance_name_ar', 'clearance_name_en', 'import_date', 'key', 'text']
			for (const key in this.selectedProduct) {
				if (this.selectedProduct.hasOwnProperty(key) && noK.indexOf(key) == -1) {
					const p = this.selectedProduct[key];
					if(p && p !=0 && p != '0' && p!= ''){
						this.clearancePrices.push({
							text:key.split('_').join(' '),
							name:key,
							price:p
						})
					}
				}
			}
		}
	},
	async created(){
		this.getProducts()
		this.getLoadData()
		this.getCatsWare()
		
		let products = await db.ref(`products`).orderByChild('clearance').equalTo(true).once('value').then(x=>x.val())
		let productsArr = []
		for (const key in products) {
			if (products.hasOwnProperty(key)) {
				const product = products[key];
				productsArr.push({
					key,
					name:product.item_name,
					warehouse:product.warehouse,
					name_ar:product.name_ar,
					description_ar:product.description_ar,
					name_en:product.name_en,
					description_en:product.description_en,
					img:product.img,
					clearance_name_ar:product.clearance_name_ar,
					clearance_name_en:product.clearance_name_en,
					sku:product.sku
				})
			}
		}
		console.log(productsArr)
	}
}
</script>

<style>

</style>
